import { Typography } from "@mui/material";
import type { FC } from "react";
import { LabeledValueRow } from "web_myplann/Shared/Components/LabeledValueRow";

type Props = {
	label: string;
	value: string;
	valueColor?: string;
};

export const InspirationValueRow: FC<Props> = ({
	label,
	value,
	valueColor,
}) => {
	return (
		<LabeledValueRow
			label={<Typography variant="body2">{label}</Typography>}
			value={
				<Typography variant="bodyMedium" color={valueColor} tabular>
					{value}
				</Typography>
			}
		/>
	);
};
